import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MerchantProfileService } from '../services';


export class MerchantProfileNameValidator {
    public static validate = (merchantProfileService: MerchantProfileService, merchantProfileId: number = null): AsyncValidatorFn => {
        return (control: AbstractControl): Observable<{ [key: string]: boolean }> => {
            return merchantProfileService.isMerchantProfileNameUnique(control.value, merchantProfileId
            ).pipe(
                map(isUnique => {
                    return isUnique ? null : { notUnique: true };
                })
            );
        }
    }
}